import { useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { krispCall } from "../lib/api";

// The full transcript, only when someone asks for it. It is saved with the call but kept out of the way.
export default function KrispTranscript({ id }) {
  const [text, setText] = useState(null);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    if (text !== null) return;
    setBusy(true);
    try { setText((await krispCall(id)).transcript || "No transcript yet."); } catch { setText("Couldn't load the transcript."); } finally { setBusy(false); }
  };
  return <div className="krisp-transcript">
    <button className="link-button" onClick={toggle} data-testid="krisp-transcript-toggle">{busy ? <Loader2 size={12} className="spin" /> : <FileText size={12} />} {open ? "Hide transcript" : "View transcript"}</button>
    {open && text !== null && <pre className="transcript-body">{text.replace(/\*\*/g, "")}</pre>}
  </div>;
}
